var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{staticClass:"edudash-textarea",attrs:{"label":"Escrever diário","disabled":_vm.disabled,"change":_vm.emitChange(),"rules":_vm.rules},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }